import { render } from "./ChevronP.vue?vue&type=template&id=91d77af6"
const script = {}
script.render = render

export default script